import { MODALS } from 'common/domain/constants';
import { STATES } from 'common/domain/states';

class EmployeeAfkController {
  constructor(employeeAfkService, $state, EventEmitter) {
    'ngInject';
    this.employeeAfkService = employeeAfkService;
    this.state = $state;
    this.eventEmitter = EventEmitter;
    this.employees = [];
    this.employeesNumber = '00';
  }

  $onInit() {
    this.urlDestination = STATES.VACATIONS_ABSENCES.DELEGATE;
    this._initData();
  }

  _initData() {
    this.employeeAfkService.getEmployeesAfk(this.userId).then(({ employees, employeesNumber }) => {
      this.employees = employees;
      this.employeesNumber = employeesNumber;
    });
  }

  get modalWarningDelegation() {
    const $modal = $(MODALS.WARNING_DELEGATION_MODAL);
    return $modal;
  }

  onSelectEmployee($event) {
    if (this.hasDelegated) {
      return this._showModalWarningDelegation();
    }

    const from = this.getStateNested(this.state.current.name) || '';
    this.sendIncept(this.eventEmitter({ from: from, employee: $event.employeeId }));
  }

  _showModalWarningDelegation() {
    this.modalWarningDelegation.modal('show');
  }

  getStateNested(state) {
    return state.split(`${STATES.VACATIONS_ABSENCES.ROOT}.`)[1] || '';
  }
}

export default EmployeeAfkController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/employeeAfk/employeeAfk.controller.js